import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { Observable } from 'rxjs';
import { ResposeGeneric } from 'src/app/core/shared/respose-generic';
import { Endorse } from './endorse.model';

@Injectable()
export class EndorsesService {
  uriEndorse = environment.urlServices + 'avales';
  uriEndorses = environment.urlServices + 'solicitudes/avales';
  uriEndorsesDetail = environment.urlServices + 'solicitudes/detalles/avales';

  constructor(private httpClient: HttpClient, private utilService: UtilityService) { }

  getRequets(cedula, tipo): Observable<ResposeGeneric> {
    const param = {cedula : cedula, tipo: tipo};
    return this.httpClient.get<ResposeGeneric>(this.utilService.addQueryParam(this.uriEndorses, param));
  }

  getRequetsDetial(solicitud): Observable<ResposeGeneric> {
    const param = {solicitud : solicitud};
    return this.httpClient.get<ResposeGeneric>(this.utilService.addQueryParam(this.uriEndorsesDetail, param));
  }

  sendEndorse(endorse: Endorse): Observable<ResposeGeneric> {
    return this.httpClient.post<ResposeGeneric>(this.uriEndorse, endorse);
  }


}
